import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order__info-main" }
const _hoisted_2 = { class: "order__info-headline" }
const _hoisted_3 = { class: "order__info-body" }
const _hoisted_4 = { class: "order__info-main" }
const _hoisted_5 = { class: "order__info-headline" }
const _hoisted_6 = { class: "order__info-body" }

interface IContent {
  labelText: string
  bodyText: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    content: null,
    additionalCssClasses: null
  },
  setup(__props: any) {

const props = __props as {
  content: IContent[]
  additionalCssClasses?: string
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["order__info order__info-scannable", props.additionalCssClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(props.content[0].labelText) + ":", 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(props.content[0].bodyText), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, _toDisplayString(props.content[1].labelText) + ":", 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(props.content[1].bodyText), 1)
    ])
  ], 2))
}
}

})